import LogoHeader from './../assets/images/icons/logo-header.png';
import LogoShort from './../assets/images/icons/logo-short.png';
import Documenticon from './../assets/images/icons/folder.png';
import ReqIcon from "./../assets/images/icons/req.png";
import NoPermission from "./../assets/images/icons/n-permission.png";

const IMAGES = {
    LogoHeader: LogoHeader,
    LogoShort: LogoShort,
    Documenticon: Documenticon,
    ReqIcon: ReqIcon,
    NoPermission: NoPermission,
}
export default IMAGES